export default {
  name: "CalendarPendingSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 6h-3.5V3.5a1.5 1.5 0 1 0-3 0V6h-11V3.5a1.5 1.5 0 1 0-3 0V6H4c-1.16 0-2 .84-2 2v20c0 1.16.84 2 2 2h24c1.16 0 2-.84 2-2V8c0-1.16-.84-2-2-2zm-5.61 16.56a1.5 1.5 0 0 1-1.95.84l-5-2a1.5 1.5 0 0 1-.94-1.39v-7a1.5 1.5 0 1 1 3 0v5.98l4.06 1.62a1.5 1.5 0 0 1 .83 1.95z",
  },
}
